export function toPrettyJson(value: unknown): string {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function buildPrepareFileResultContent(
  output: string | undefined,
): string {
  if (!output) {
    return '';
  }

  try {
    const parsed: unknown = JSON.parse(output);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return output;
    }

    const record = { ...(parsed as Record<string, unknown>) };
    if (
      typeof record.base64Content === 'string' &&
      record.base64Content.length > 48
    ) {
      record.base64Content = `${record.base64Content.slice(0, 48)}...`;
    }

    return toPrettyJson(record);
  } catch {
    return output;
  }
}
